var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBreweryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.94L15.3033 13.6366C16.3522 12.5877 17.0665 11.2514 17.3559 9.79652C17.6453 8.34166 17.4968 6.83367 16.9291 5.46323C16.3614 4.09279 15.4001 2.92145 14.1668 2.09735C12.9334 1.27324 11.4834 0.833374 10 0.833374C8.51665 0.833374 7.0666 1.27324 5.83324 2.09735C4.59987 2.92145 3.63858 4.09279 3.07092 5.46323C2.50326 6.83367 2.35473 8.34166 2.64411 9.79652C2.93349 11.2514 3.64779 12.5877 4.69667 13.6366L10 18.94ZM10 11.6667C11.8409 11.6667 13.3333 10.1743 13.3333 8.33337C13.3333 6.49242 11.8409 5.00004 10 5.00004C8.15905 5.00004 6.66667 6.49242 6.66667 8.33337C6.66667 10.1743 8.15905 11.6667 10 11.6667Z",
    fill: "#3E404C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 8,
    r: 3,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreweryIcon);
export default __webpack_public_path__ + "static/media/BreweryIcon.3277d4f9ff9f16e2d28254b8ff01820c.svg";
export { ForwardRef as ReactComponent };